import { cls } from "@wss/cls";
import React, { HTMLAttributes } from "react";

type RecaptchaDisclaimerProps = HTMLAttributes<HTMLSpanElement> & {
  anchorProps?: HTMLAttributes<HTMLAnchorElement>;
};

export function RecaptchaDisclaimer({
  anchorProps,
  className,
  ...rest
}: RecaptchaDisclaimerProps) {
  return (
    <span
      className={cls(
        "block mt-2.5 text-2xs leading-tight text-gray-600",
        className,
      )}
      {...rest}
    >
      This form is protected by reCAPTCHA and the Google
      <br />
      <a
        href="https://policies.google.com/privacy"
        rel="noopener noreferrer"
        target="_blank"
        className={cls("underline text-green-500", anchorProps?.className)}
        {...anchorProps}
      >
        Privacy Policy
      </a>{" "}
      and{" "}
      <a
        href="https://policies.google.com/terms"
        rel="noopener noreferrer"
        target="_blank"
        className={cls("underline text-green-500", anchorProps?.className)}
        {...anchorProps}
      >
        Terms of Service
      </a>{" "}
      apply.
    </span>
  );
}
